"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyUserProfilePermissionMenuItems = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var classnames = require("classnames");
require("./index.scss");
var getCategory_1 = require("utils/helpers/getCategory");
var userGroups_1 = require("utils/userGroups");
var CopyUserProfilePermissionMenuItems = function (props) { return (React.createElement(React.Fragment, null, props.groups
    .filter(function (curr) { return props.includeCategoryTypes.includes(curr.category.type); })
    .reduce(function (prev, curr) {
    prev.push(__assign(__assign({}, curr.category), { disabled: props.disableCategoryTypes.includes(curr.category.type) }));
    curr.groups.forEach(function (g) {
        g.name = (0, userGroups_1.getLocalizedUserGroupName)(g.name);
        return prev.push(g);
    });
    return prev;
}, [])
    .filter(function (item) {
    return !(props.filterGroupsWithId &&
        props.filterGroupsWithId.includes(item.id));
})
    .map(function (item, key) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { className: classnames('sok-invitation-modal-menu-item', item.disabled && 'disabled'), key: item.id, selected: false, onClick: function () {
        return !item.disabled && props.setCopiedUserProfile(item);
    } }, item.disabled ? (React.createElement("strong", null, (0, getCategory_1.getCategoryName)(item))) : (React.createElement("span", null, item.name)))); }))); };
exports.CopyUserProfilePermissionMenuItems = CopyUserProfilePermissionMenuItems;
